import React from 'react';
import { product, purchaseDetails } from '../../data/product';
import { PrimaryButton } from './PrimaryButton';
export function OfferSection() {
  return <section id="comprar" aria-labelledby="oferta-titulo" className="w-full border-t border-sand bg-ivory" data-id="element-125" data-mp="1onc86j3fcdql">
      <div className="mx-auto max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-126" data-mp="1klh5ba5uhsap">
        <div className="grid overflow-hidden rounded-sm bg-paper lg:grid-cols-12" data-id="element-127" data-mp="1fm4bg5gk3kym">
          <img src={product.mockupImage} alt="" aria-hidden="true" className="hidden w-full object-cover object-right lg:col-span-5 lg:block lg:h-full" data-id="element-128" data-mp="2c9inzrj3axrd" />
          <div className="flex flex-col justify-center p-8 sm:p-12 lg:col-span-7 lg:p-16" data-id="element-129" data-mp="23gxj9fcamrlj">
            <h2 id="oferta-titulo" className="font-serif text-[2rem] font-normal leading-[1.12] tracking-tight text-carbon sm:text-4xl lg:text-[2.75rem]" data-id="element-130" data-mp="1yim54seytuxi">
              Tu vida no tiene que seguir esperando.
            </h2>
            <p className="mt-4 font-serif text-xl italic text-gold-ink" data-id="element-131" data-mp="3ch9z39317b7m">
              Deja de recalcular. Empieza a vivir.
            </p>

            <div className="mt-10 border-t border-sand pt-8" data-id="element-132" data-mp="3hgd08ifw4xab">
              <div className="rounded-sm border border-sand bg-ivory p-5 sm:p-6" data-id="element-133" data-mp="33q9o4kaq6jyl">
                <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-134" data-mp="37qtkhlnh5jjo">
                  <p className="text-sm text-stone" data-id="element-135" data-mp="2trab6pixg25s">
                    Antes{' '}
                    <s className="ml-1 text-base text-stone decoration-gold decoration-[1.5px]" data-id="element-136" data-mp="2ttd8zvqbmzl2">
                      <span className="sr-only" data-id="element-137" data-mp="2yoait4vfdcz0">precio anterior </span>
                      {product.compareAtPrice}
                    </s>
                  </p>
                  <span className="inline-flex items-center rounded-full bg-gold px-3 py-1 text-xs font-semibold text-carbon" data-id="element-138" data-mp="2osz24h0ghvom">
                    Ahorras {product.savingsAmount} · {product.savingsPercent}
                  </span>
                </div>
                <p className="mt-3 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-139" data-mp="1vxrh6ya0vac8">
                  <span className="font-serif text-5xl leading-none tracking-tight text-carbon sm:text-6xl" data-id="element-140" data-mp="1vvolbxm6umzl">
                    <span className="sr-only" data-id="element-141" data-mp="1r10zy7mhe8p8">Precio actual: </span>
                    {product.priceAmount}
                  </span>
                  <span className="text-sm font-medium text-carbon" data-id="element-142" data-mp="1hyrv9ydw99jr">{product.priceCurrency}</span>
                  <span className="text-sm text-stone" data-id="element-143" data-mp="2eoin1puswilv">· {product.priceNote}</span>
                </p>
                <p className="mt-3 border-t border-sand pt-3 text-sm text-stone" data-id="element-144" data-mp="2amfasz0b59zj">
                  Ebook completo + programa RESET 21 incluido.
                </p>
              </div>
              <PrimaryButton label={product.ctaLabel} href={product.productUrl} target="_top" className="mt-6 w-full sm:w-auto" data-id="element-145" data-mp="20xdvzc5i0yn5" />
              <ul className="mt-5 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-stone" data-id="element-146" data-mp="2tl9pk7zruafp">
                {purchaseDetails.map((detail, index) => <li key={detail} className="flex items-center gap-2" data-id="element-147" data-mp="30z0tuedgb6ym" data-mpi={index}>
                    {index > 0 && <span aria-hidden="true" className="text-gold" data-id="element-148" data-mp="35w0xyjqqpzn3">·</span>}
                    {detail}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}